import React, { FC, useEffect, useState } from 'react';
import Section from '@widgets/components/section';
import { IHosting } from '@entities/hosting/IHosting';
import SectionHeader from '@widgets/components/section-header';
import TagInput from '@widgets/tag-input';
import InputFiles from '@shared/uikit/input-files';

interface IManagerInfoProps {
  hosting?: IHosting | null;
}
const HostingInfoTab: FC<IManagerInfoProps> = ({ hosting }) => {
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    (() => {
      setLocations(hosting?.locations);
    })();
  }, [hosting]);

  return (
    <>
      <Section>
        <div className="flex text-[20px] mb-[20px]">
          <SectionHeader title="Общие сведения" />
        </div>
        <div className="grid md:grid-cols-5 gap-8 pb-[30px] mb-[20px] border-b border-[#211F24]">
          <div className="w-full">
            <div className="mb-[10px] text-[#959595]">Общая мощность</div>
            <div
              className={`h-[39px] w-full rounded-[8px] text-[12px] bg-[#141316] px-[10px] flex items-center border border-solid border-[#2B292F]`}
            >
              <span className="text-[16px]">{hosting?.common_power} МВТ</span>
            </div>
          </div>
          <div className="w-full">
            <div className="mb-[10px] text-[#959595]">Номинальная мощность</div>
            <div
              className={`h-[39px] w-full rounded-[8px] text-[12px] bg-[#141316] px-[10px] flex items-center border border-solid border-[#2B292F]`}
            >
              <span className="text-[16px]">{hosting?.nominal_power} МВТ</span>
            </div>
          </div>
          <div className="w-full">
            <div className="mb-[10px] text-[#959595]">Фактическая мощность</div>
            <div
              className={`h-[39px] w-full rounded-[8px] text-[12px] bg-[#141316] px-[10px] flex items-center border border-solid border-[#2B292F]`}
            >
              <span className="text-[16px]">{hosting?.actual_power} МВТ</span>
            </div>
          </div>
          <div className="w-full">
            <div className="mb-[10px] text-[#959595]">Доля Interhash</div>
            <div
              className={`h-[39px] w-full rounded-[8px] text-[12px] bg-[#141316] px-[10px] flex items-center border border-solid border-[#2B292F]`}
            >
              <span className="text-[16px]">{hosting?.percent_of_power} %</span>
            </div>
          </div>
          <div className="w-full">
            <div className="mb-[10px] text-[#959595]">Свободная мощность</div>
            <div
              className={`h-[39px] w-full rounded-[8px] text-[12px] bg-[#141316] px-[10px] flex items-center border border-solid border-[#2B292F]`}
            >
              <span className="text-[16px]">{hosting?.free_power} МВТ</span>
            </div>
          </div>
        </div>
        <div className="flex w-full pb-[30px] mb-[30px] border-b border-[#211F24]">
          <div className="w-full">
            <div className="mb-[10px] text-[#959595]">Локации</div>
            {hosting ? (
              <TagInput
                values={locations}
                placeholder="Введите название лоакации"
                onAdd={(value: string) => {
                  if (value.trim() && !hosting?.locations.includes(value)) {
                    setLocations([...locations, value]);
                  }
                }}
                onRemove={(value: string) => {
                  setLocations(locations.filter(item => value !== item));
                }}
              />
            ) : null}
          </div>
        </div>
        <div>
          <InputFiles />
        </div>
      </Section>
    </>
  );
};

export default HostingInfoTab;
